import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [{
      path: '/',
      redirect: '/mine',
      // redirect: '/login',
    },

    {
      path: '/login',
      name: 'login',
      component: () => import('../views/login/index')
    },
    {
      path: '/forget',
      name: 'forget',
      component: () => import('../views/forget/index')
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: () => import('../views/agreement/index')
    },
    {
      path: '/mine',
      name: 'mine',
      component: () => import('../views/mine/index')
    },
    {
      path: '/mine/orderList/:id',
      name: 'orderList',
      component: () => import('../views/mine/orderList/index')
    },
    {
      path: '/mine/Benefits',
      name: 'Benefits',
      component: () => import('../views/mine/Benefits/index')
    },
    {
      path: '/mine/news',
      name: 'news',
      component: () => import('../views/mine/news/index')
    },
    {
      path: '/mine/offer',
      name: 'offer',
      component: () => import('../views/mine/offer/index')
    },
    {
      path: '/mine/map',
      name: 'map',
      component: () => import('../views/mine/map/index')
    },
    {
      path: '/mine/changes/:id',
      name: 'changes',
      component: () => import('../views/mine/changes/index')
    },
    {
      path: '/mine/add',
      name: 'add',
      component: () => import('../views/mine/add/index')
    },
    {
      path: '/mine/remind',
      name: 'remind',
      component: () => import('../views/mine/remind/index')
    },
    {
      path: '/mine/aboutUs',
      name: 'aboutUs',
      component: () => import('../views/mine/aboutUs/index')
    },
    {
      path: '/mine/feedback',
      name: 'feedback',
      component: () => import('../views/mine/feedback/index')
    },
    {
      path: '/mine/commission',
      name: 'commission',
      component: () => import('../views/mine/commission/index')
    },
    {
      path: '/mine/commission/addSchedule',
      name: 'addSchedule',
      component: () => import('../views/mine/commission/addSchedule/index')
    },
    {
      path: '/mine/getCommission',
      name: 'getCommission',
      component: () => import('../views/mine/getCommission/index')
    },
    {
      path: '/mine/schedule',
      name: 'schedule',
      component: () => import('../views/mine/schedule/index')
    },
    {
      path: '/mine/Withdrawal',
      name: 'Withdrawal',
      component: () => import('../views/mine/Withdrawal/index')
    },
    {
      path: '/mine/Withdrawal/catch',
      name: 'catch',
      component: () => import('../views/mine/Withdrawal/catch/index')
    },
    {
      path: '/mine/Modify',
      name: 'Modify',
      component: () => import('../views/mine/Modify/index')
    }
  ]
})

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next();
  } else if (to.path === '/forget') {
    next();
  } else if (to.path === '/agreement') {
    next();
  } else {
    let token = localStorage.getItem('id');
    if (!token && to.path !== '/login') {
      next('/login');
    } else {
      next();
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js